export default "__VITE_ASSET__CoGqsFYg__"